var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGooglePlay = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 11.8261,
  height: 13.9131,
  viewBox: "0 0 11.8261 13.9131",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons"
}, /*#__PURE__*/React.createElement("path", {
  id: "google_play-[#133]",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.38365e-05 13.8631V13.913L5.91306 10.4348L8.06656 9.17221L6.35294 7.44701L1.38365e-05 13.8631ZM8.66197 5.1019L6.81886 6.95652L8.66197 8.81182L11.8261 6.95652L8.66197 5.1019ZM8.04669 4.74151L5.91306 3.47826L1.38365e-05 0V0.0499321L6.35294 6.46671L8.04669 4.74151ZM5.89182 6.93342L1.38365e-05 12.8815V6.95652V0.98981L5.89182 6.93342Z",
  fill: "#FDF8ED"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGooglePlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-google-play.e2eab9e8de8a7235b3717b62ef1e5dc9.svg";